<template>
  <div class="section-row module-breadcrumb tx-odu-partnumbersearch--breadcrumb -bg-border-light">
    <div class="col-wrapper -max-width-limited">
      <div class="col">
        <div class="module-nav module-nav--breadcrumb">
          <div class="breadcrumb__back">
            <span @click="goBack()"><i class="icon-angle-left-before"></i><span>{{ $t('list.breadcrumb.back') }}</span></span>
          </div>
          <div class="swiper-container">
            <div class="swiper-wrapper">
              <div class="swiper-slide module-nav__item">
                <a :href="store.entryLink">
                  <span>{{ $t('list.breadcrumb.home') }}</span>
                </a>
              </div>
              <div class="swiper-slide module-nav__item module-nav__item--active">
                <span>{{ $t('list.breadcrumb.partnumbersearch') }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="section-row tx-odu-partnumbersearch-extended-list -padded-wide -bg-alpha-light" v-if="!store.loading">
    <div class="col-wrapper l-1col -max-width-limited">
      <div class="col">
        <div class="content-item module-selected-filter">
          <div class="selected-filter-wrapper">
            <SelectedFilterWrapper filterType="List"></SelectedFilterWrapper>
          </div>
          <div class="module-cart-btn" ref="mobileButtonHolder">
            <div class="btn -btn-filter" @click="mobileFilterOpen = !mobileFilterOpen" ref="mobileButton">
              <span class="">{{ $t('list.filter.headline') }}</span>
            </div>
            <div class="filter-btn-placeholder"></div>
            <div class="btn -btn-alpha" @click="cartStore.overlay = true">
              <span class="icon-cart-alternative-filled-before">{{ $t('list.cartbtn') }} ({{cartStore.items.length}})</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-wrapper l-2col-b2-25-75 l-2col-b2-25-75--normal -max-width-limited">
      <div class="col col-one">
        <FilterWrapper @closeFilter="mobileFilterOpen = false" :mobileFilterOpen="mobileFilterOpen" v-if="!store.error" filterType="List"></FilterWrapper>
      </div>
      <div class="col col-two">
        <div class="content-item module-list" v-if="!store.error">
          <PartsList
          :items="parts.items"></PartsList>
          <PaginationWrapper
          :currentPage="parts.currentPage"
          :recordsPerPage="parts.itemsPerPage"
          :totalRecords="parts.numberOfTotalItems"
          @change-current-page="paginate($event)"
          v-if="store.initialized && parts.numberOfTotalItems > parts.itemsPerPage"></PaginationWrapper>
        </div>
        <div v-if="store.error">
          <div class="no-reuslts">
            <span>{{ $t('list.error') }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="section-row tx-odu-partnumbersearch-extended-list -padded-wide -bg-alpha-light loading--placeholder" v-else>
    <div class="col-wrapper l-1col -max-width-limited">
      <div class="col">
        <div class="content-item module-selected-filter module-selected-filter--placeholder">
          <div class="selected-filter-wrapper">
            <div class="selected-filter--placeholder"></div>
            <div class="selected-filter--placeholder"></div>
            <div class="selected-filter--placeholder"></div>
          </div>
          <div class="module-cart-btn--placeholder"></div>
        </div>
      </div>
    </div>
    <div class="col-wrapper l-2col-b2-25-75 l-2col-b2-25-75--normal -max-width-limited">
      <div class="col col-one">
        <div class="module-filter-wrapper">
          <div class="filter__headline--placeholder"></div>
          <div class="filter-wrap">
            <div class="filter__search--placeholder"></div>
            <div class="filter__option--placeholder"></div>
          </div>
          <div class="filter-wrap">
            <div class="filter-wrap__headline--placeholder"></div>
            <div class="filter__option--placeholder"></div>
            <div class="filter__option--placeholder"></div>
            <div class="filter__option--placeholder"></div>
          </div>
          <div class="filter-wrap">
            <div class="filter-wrap__headline--placeholder"></div>
            <div class="filter__option--placeholder"></div>
            <div class="filter__option--placeholder"></div>
            <div class="filter__option--placeholder"></div>
          </div>
          <div class="filter-wrap">
            <div class="filter-wrap__headline--placeholder"></div>
            <div class="filter__option--placeholder"></div>
            <div class="filter__option--placeholder"></div>
            <div class="filter__option--placeholder"></div>
          </div>
          <div class="filter-wrap">
            <div class="filter-wrap__headline--placeholder"></div>
            <div class="filter__option--placeholder"></div>
            <div class="filter__option--placeholder"></div>
            <div class="filter__option--placeholder"></div>
          </div>
          <div class="filter-wrap">
            <div class="filter-wrap__headline--placeholder"></div>
            <div class="filter__option--placeholder"></div>
            <div class="filter__option--placeholder"></div>
            <div class="filter__option--placeholder"></div>
          </div>
          <div class="filter-wrap">
            <div class="filter-wrap__headline--placeholder"></div>
            <div class="filter__option--placeholder"></div>
            <div class="filter__option--placeholder"></div>
            <div class="filter__option--placeholder"></div>
          </div>
        </div>
      </div>
      <div class="col col-two">
        <div class="content-item module-list">
          <div class="items-wrapper">
            <template v-for="index in 6" :key="index">
              <div class="item__item">
                <div class="item__main">
                  <div class="item__image--placeholder">
                  </div>
                  <div class="item__content">
                    <div class="content__meta--placeholder">
                      <div class="meta__id--placeholder"></div>
                      <div class="meta__link--placeholder"></div>
                    </div>
                    <div class="content__description--placeholder"></div>
                  </div>
                </div>
                <div class="item__bottom">
                  <div class="bottom__filter">
                    <div class="item__filter--placeholder"></div>
                    <div class="item__filter--placeholder"></div>
                    <div class="item__filter--placeholder"></div>
                    <div class="item__filter--placeholder"></div>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useGlobalStore } from '@/stores'
import PartsList from '@/components/PartsList'
import FilterWrapper from '@/components/FilterWrapper'
import SelectedFilterWrapper from '@/components/SelectedFilterWrapper'
import PaginationWrapper from '@/components/PaginationWrapper'
import { usePartsStore } from '@/stores/parts'
import { useCartStore } from '@/stores/cart'
import { useFilterStore } from '@/stores/filter'
import {onMounted, ref} from 'vue';

const store = useGlobalStore()
const parts = usePartsStore()
const cartStore = useCartStore()
const globalStore = useGlobalStore()
const filterStore = useFilterStore()
store.init()

const mobileFilterOpen = ref(false)
const mobileButtonHolder = ref(null)
const mobileButton = ref(null)


function goBack ()
{
  window.history.back()
}

function paginate (page) {
  parts.currentPage = page
  window.scrollTo(0, 0, 'smooth')
  globalStore.filter()
}

function scrollingFilterButton () {
  if (mobileButtonHolder.value && mobileButton.value) {
    const wrapperRec = mobileButtonHolder.value.getBoundingClientRect()
    const triggerStart = wrapperRec.top
    if (triggerStart < 20) {
      mobileButton.value.classList.add('-fixed')
    } else {
      mobileButton.value.classList.remove('-fixed')
    }
  }
}


onMounted(() =>
{
  filterStore.clearSelectedFilters()
  scrollingFilterButton()
  window.addEventListener('scroll', scrollingFilterButton)
  window.addEventListener('resize', scrollingFilterButton)

})
</script>
